import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_32jxh7lm9h: FaireBrandEntity = {
  token: "b_32jxh7lm9h",
  type: "brand",
  name: "Indie & Co. | Women's Apparel",
  avatarUrl:
    "https://cdn.faire.com/fastly/03c2410c2e257cb71531f9cc74bde1fe20ef4654104293c46ddd1d741add9e30.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3c96ee004f73bd671b12d14bef66b57d5bbe95d863b00c773acb4ad9bcb0fabb.png",
  logoUrl:
    "https://cdn.faire.com/fastly/03c2410c2e257cb71531f9cc74bde1fe20ef4654104293c46ddd1d741add9e30.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3c96ee004f73bd671b12d14bef66b57d5bbe95d863b00c773acb4ad9bcb0fabb.png",
  location: "Logan, UT, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 64,
  isInsider: true,
  description:
    "Two sisters that love fashion, Sara and Rachel, started A Dip of \nDarling. We grew up working in a family floral business. It was a \nbusiness that encouraged creativity and imagination, and we had great\nsuccess managing that business as a team. Once we were both \nmarried and started having children of our own, our desire was to be \nable to be home with them. We started out with inventory in a garage \nand shipping over the kitchen counter, but quickly found more room \nwas necessary!\n\nAbout six months into our business we were able to \nfind a warehouse that also had a room that could be used as a small \nstorefront to allow our product to be displayed. It wasn’t long after \nthat, that we found the need to move to a larger location. We have \nbeen blessed with loyal clientele locally and nationwide.\nIn 2021, Rachel went on to new adventures while Sara decided to \nrebrand A Dip of Darling into Indie & Co.\n\nThe business has had success in providing \nfashionable clothing in extended sizes, which seems to be filling a \nniche. It has been exciting to set goals and reach them.\n\nWe are so grateful for our customers that continue to make \nthis business what it is.\n\nThank you from the bottom of our hearts!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:09.754Z",
    importedBy: "entity-db-cli",
  },
};
